import {
  dishDetailsViewTranslation,
  DishDetailsViewTranslation,
} from '@/assets/locales/views/dishes/details/dishDetailsView.translation.pl.ts';
import {
  dishEditorTranslation,
  DishEditorTranslation,
} from '@/assets/locales/views/dishes/editor/dishEditor.translation.pl.ts';
import {
  dishesListViewTranslation,
  DishesListViewTranslation,
} from '@/assets/locales/views/dishes/list/dishesListView.translation.pl.ts';

export type DishesTranslation = {
  details: DishDetailsViewTranslation;
  editor: DishEditorTranslation;
  list: DishesListViewTranslation;
};

export const dishesTranslation: DishesTranslation = {
  details: dishDetailsViewTranslation,
  editor: dishEditorTranslation,
  list: dishesListViewTranslation,
};
